interface ProfileTabsInterface {
  url: string;
  key: ProfileTabsType;
  hide?: boolean;
  disabled?: boolean;
}

export const ProfileTabsEnum = {
  quickView: 'quickView',
  details: 'details',
  preferences: 'preferences',
  consents: 'consents',
  roomReservations: 'roomReservations',
  venueReservations: 'venueReservations',
  loyalty: 'loyalty',
  activityTimeline: 'activityTimeline',
} as const;
export type ProfileTabsType =
  (typeof ProfileTabsEnum)[keyof typeof ProfileTabsEnum];

export const profileTabsStatic: ProfileTabsInterface[] = [
  {
    url: 'quick-view',
    key: ProfileTabsEnum.quickView,
  },
  {
    url: 'details',
    key: ProfileTabsEnum.details,
  },
  {
    url: 'preferences',
    key: ProfileTabsEnum.preferences,
    hide: true,
  },
  {
    url: 'consents',
    key: ProfileTabsEnum.consents,
  },
  {
    url: 'room-reservations',
    key: ProfileTabsEnum.roomReservations,
  },
  {
    url: 'venue-reservations',
    key: ProfileTabsEnum.venueReservations,
    hide: true,
  },
  {
    url: 'loyalty',
    key: ProfileTabsEnum.loyalty,
    hide: true,
  },
  {
    url: 'activity-timeline',
    key: ProfileTabsEnum.activityTimeline,
    disabled: true,
    hide: true,
  },
];
